export { default } from "./Header";
export { Header, HeaderQuickAccessItem, addHeaderTranslations, useTranslation } from "./Header";
//# sourceMappingURL=index.js.map